//
// Store dialer (PI box) results in browser via rxdb and sync with testbed postgres
//

import { RxJsonSchema, RxDocument } from 'rxdb';
import { TestSeq } from '../models';


export const testSeqMethods = {
}

export type TestSeqDoc = RxDocument<TestSeq,typeof  testSeqMethods>

export const testSeqSchema: RxJsonSchema<TestSeq> = {
    title: 'dialer result and import status',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        seqid: {
            primary: true,
            type: 'string'
        },
        testPointId: {
            type: 'string'
        },
        userId: {
            type: 'string'
        },
        stage: {
            type: 'string'
        },
        groupingfield: {
            type: ['string','null']
        },
        buildingId: {
            type: 'string'
        },
        pathId: {
            type: 'string'
        },
        pointId: {
            type: 'string'
        },
        cycle: {
            type: 'number'
        },
        testOrder: {
            type: 'number'
        },
        importTime: {
            type: ['string', 'null']
        },
        startTime: {
            type: ['string', 'null']
        },
        endTime: {
            type: ['string', 'null']
        },
        dialer: {
            type: ['object', 'null']
        },
        status: {
            type: ['string', 'null']
        },
        updatedAt: { type: 'number' }
    },

    required: ['testPointId'],
    
    indexes: [
        'testPointId'
    ]
};

//const testSeqFields = [ ...Object.keys(new TestSeq()), 'deleted' ]
const varDefs = {
    seqid: 'ID!',
    testPointId: 'String',
    userId: 'String', 
    stage: 'String', 
    buildingId: 'String',
    pathId: 'String', 
    pointId: 'String', 
    cycle: 'Float', 
    testOrder: 'Float', 
    importTime: 'DateTime', 
    startTime: 'DateTime', 
    endTime: 'DateTime',
    dialer: 'String', 
    status: 'String', 
    groupingfield: 'String',
    updatedAt: 'Float',
    deleted: 'Boolean'
}

const varNames = Object.keys(varDefs)

export const testSeqPullQueryBuilder = () => {
    
    const query = 'query FeedForRxdbTestSeqs($lastId: String!, $minUpdatedAt: Float! ){ '+
        'feedForRxdbTestSeqs(lastId: $lastId, minUpdatedAt: $minUpdatedAt ) {' + varNames.join(' ') +'}}';

    return (doc : TestSeq) => {
        const rtn = {
            query,
            variables: {
                lastId: !doc ? '' : doc.seqid,
                minUpdatedAt: !doc ? 0 : doc.updatedAt
            }
        };
        //console.log(`testSeqPullQueryBuilder() updatedAt=${doc?.updatedAt}`);console.dir(rtn)
        return rtn
    };

};

export const testSeqPushQueryBuilder = () => {
    const paramSigs = Object.entries(varDefs).map(([name,type])=>'$'+name+':'+type).join(',')
    const paramBindings = varNames.map(name=>name+':$'+name).join(',')
    const query = 'mutation CreateTestSeqs(' + paramSigs + '){ ' +
        'createTestSeqs(args:[{' + paramBindings + '}]){ seqid, status, updatedAt }}';

    return (doc : TestSeq) => {

        let variables : any = {}
        for( const varName of varNames ) {
            variables[varName] = doc[varName]
        }
        
        const rtn = {
            query,
            variables
        };
        console.log(`testSeqPushQueryBuilder() updatedAt=${doc.updatedAt}`);console.dir(rtn)
        return rtn
    };
};